import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Spinner from '@atlaskit/spinner';

import type { FlagsStateContainer } from '@confluence/flags';

const i18n = defineMessages({
	errorIconLabel: {
		id: 'bulk-permissions.flag-message.error-icon-label.non-final',
		defaultMessage: 'Error',
		description: 'The label for the error icon',
	},
	processingFlagTitle: {
		id: 'bulk-permissions.flag-message.processing.non-final',
		defaultMessage: 'Bulk permissions change processing',
		description: 'The title for the processing flag',
	},
	processingFlagContent: {
		id: 'bulk-permissions.flag-message.processing-content.non-final',
		defaultMessage: 'These changes can take a while. We’ll notify you when it’s finished.',
		description: 'The content for the processing flag',
	},
	errorFlagTitle: {
		id: 'bulk-permissions.flag-message.error.non-final',
		defaultMessage: 'Bulk access change failed',
		description: 'The title for the error flag',
	},
	errorFlagContent: {
		id: 'bulk-permissions.flag-message.error-content.non-final',
		defaultMessage: 'We ran into a problem completing your bulk access change. Try again.',
		description: 'The content for the error flag',
	},
});

export const useBulkRoleFlags = ({ flags }: { flags: FlagsStateContainer }) => {
	const { formatMessage } = useIntl();

	const showErrorFlag = () =>
		flags.showErrorFlag({
			id: `error-${Date.now()}`,
			title: formatMessage(i18n.errorFlagTitle),
			description: formatMessage(i18n.errorFlagContent),
			isAutoDismiss: true,
		});

	const showProcessingFlag = () =>
		flags.showCustomFlag({
			id: `processing-${Date.now()}`,
			title: formatMessage(i18n.processingFlagTitle),
			description: formatMessage(i18n.processingFlagContent),
			customIcon: <Spinner testId="spinner" size="small" label="spinner" />,
		});

	return {
		showErrorFlag,
		showProcessingFlag,
	};
};
